// extracted by mini-css-extract-plugin
export default {"wrapper":"ELQf9Bav3zD_XRcdSlQN","period":"qGpKNZ7_HO8Fq9w9Vyrt"};